import { Component, OnInit,ViewChild } from '@angular/core';
import { KitchenStockItemService } from '../../../shared/services/kitchen-stock-item.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from '../../../shared/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from '../../../shared/services/auth.service';
import { EnvService } from '../../../shared/services/env.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { KitchenStockComponent } from '../kitchen-stock/kitchen-stock.component';


@Component({
  selector: 'ngx-kitchen-stock-list',
  templateUrl: './kitchen-stock-list.component.html',
  styleUrls: ['./kitchen-stock-list.component.scss']
})
export class KitchenStockListComponent implements OnInit {

 
  displayedColumns: string[] = ['Name', 'Unit','UnitCost','CreatedBy','Action'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;

  item : any[];

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
  
  statusCode: number;

  constructor(private kitchenStockItemService : KitchenStockItemService,
              private dialogService : DialogService,
              private router : Router, 
              private toastr: ToastrService,
              private route: ActivatedRoute,
              private themeService: NbThemeService,
              private authService: AuthService,
              private env: EnvService
              ) { }

  ngOnInit() {
    this.getAllItems();
    this.getControlPermissions();

    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });
  }

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='KS'
    });

    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }



  newButtonClick() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.width = '40%';
   this.dialogService.openDialog(KitchenStockComponent, dialogConfig)
    .afterClosed().subscribe(res => this.getAllItems());
   }

   veiwButtonClick(row){
    const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = false;
     dialogConfig.data = row;
     dialogConfig.width = "40%";
     dialogConfig.panelClass = "custom";
     this.dialogService.openDialog(KitchenStockComponent,dialogConfig)
      .afterClosed().subscribe(res => this.getAllItems());

  }
  
getAllItems(){
    this.kitchenStockItemService.getAll()
     .subscribe(
        (data) => {
                  this.item = data;
                  this.dataSource = new  MatTableDataSource (this.item );  
                  this.dataSource.sort = this.sort;
                  this.dataSource.paginator = this.paginator;  
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                 });  
       
     }

        
   
   deleteButtonClick(id){
          this.dialogService.openConfirmDialog('Are you sure you want to delete this record?')
          .afterClosed().subscribe(res =>{
            if(res){
              this.kitchenStockItemService.delete(id)
            .subscribe(
              (res) => {
                        if(res.success ==1){
                          this.toastr.success('Item was deleted successfully','Success');
                          this.getAllItems();
                          console.log(res);   
                        }

                        if(res.success ==2){
                          this.toastr.error('This item already used in stock','Warning');
                          this.getAllItems();
                          console.log(res);   
                        }
                            
                        },        
              (err) =>  {
                          this.toastr.error('Failed to delete item','Failure');
                          if(err instanceof HttpErrorResponse){                 
                            if(err.status == 401){
                              this.router.navigate(['/login']);
                            }
                          }
                          console.log(err);
                        }, 
                )
            }
          });            
      }

      applyFilter(){
        this.dataSource.filter =this.searchKey.trim().toLowerCase();

      }
      onSearchClear(){
        this.searchKey = "";
        this.applyFilter();
      }



   

}
